import { render, staticRenderFns } from "./FreshArtSlider.vue?vue&type=template&id=46941284&"
import script from "./FreshArtSlider.vue?vue&type=script&lang=js&"
export * from "./FreshArtSlider.vue?vue&type=script&lang=js&"
import style0 from "./FreshArtSlider.vue?vue&type=style&index=0&id=46941284&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports